import { Grid, Typography } from "@mui/material";
import MainTitle from "../../muiHome/mainTitle";

const Legal_aid=()=>{
return (
<Grid container spacing={2}>
<Grid item xs={12}>
    <MainTitle title="Legal Aid Clinic" />
    </Grid>

    <Grid item xs={12}>
    <Typography textAlign='left' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" >Welcome to our The primary objective of the Legal Aid Clinic at the School of Law is to empower the communities residing near the campus. It seeks to address their issues by utilizing the law as a means of social engineering, to find long-lasting solutions. Both societies are well-organized and divided into different initiatives that try to address a wide variety of challenges faced by community members.
</Typography>
    </Grid>
    <Grid item xs={12}>
    <Typography textAlign='left' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" >
    Our objective is to implement the policy and guidance provided by the National Legal Services Authority. The Clinic's objective is to offer pro bono legal assistance to those in need and those belonging to marginalized communities. Additionally, it seeks to promote social welfare by raising awareness among people about their legal rights and responsibilities. The organization runs multiple Legal Literacy Camps to promote legal knowledge among marginalized communities through effective engagement. The objective is to provide practical legal knowledge to students by offering them opportunities to understand the practical aspects of the field.
    </Typography>
    </Grid>

    <Grid item xs={12}>
    <MainTitle title="Goals:" />
    </Grid>

    <Grid item xs={12}>
    <Typography textAlign='left' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" >
      <ul>
<li>Promote legal education by organizing legal Aid/ Awareness Camps. </li>
<li>Paralegal services by the faculty and the students. </li>
<li>Providing legal assistance to marginalized individuals and communities who have challenges in accessing the legal system.</li>
</ul>
<br/><br/>
    </Typography>
    </Grid>
    <Grid item xs={12}>
    <MainTitle title="ADHIKARO KA MELA " />
    <p><b>DATE: 31ST AUGUST 2018</b></p>
    </Grid>
    <Grid item xs={12}>
    <Typography textAlign='left' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" >
    <p>MVN University, School of Law has organised ADHIKARON KA MELA on 31st August 2018. It has been organised through DALSA, to resolve the problems of the general public and awaken them about their rights. The people of the nearby villages were informed on the prior basis about the happening of such events. In ADHIKAROON KA MELA all the departments of the Haryana government came up with their stalls to provide remedies to the general public. The stalls included license authority, ration card, civil treasury, aadhar card, marriage registrar, passport authority, etc.</p>
    <p>Hon'ble Justice Mr. Ajay Kumar Mittal, Punjab and Haryana High Court, was the chief guest of the day. Hon'ble Justice Avanishjhingan, Punjab and Haryana High Court, District & Sessions Judge and Member Secretary, HLSA Mr. Puneesh Jindia, District& Sessions Judge and Chairman, DLSA Palwal Mr. Ashok Kumar VermaAddl. District & Sessions Judge, Palwal Mr.Anubhav Sharma Chief Judicial Magistrate, Palwal Mr. Sanjay Sharma Chief Judicial Magistrate & Joint Secretary, HLSA Mr. Sunil Kumar DiwanChief Judicial Magistrate & Secretary, DLSA Palwal Dr.Kavita KambojChief Judicial Magistrate & Secretary, DLSA Hisar Mr.Surender Singh Chief Judicial Magistrate & Secretary, DLSA Mewat Ms. Neeru Kanboj Chief Judicial Magistrate & Secretary, DLSA RewariMs.Kirti Jain Chief Judicial Magistrate & Secretary, DLSA Faridabad Ms. Mona Singh Chief Judicial Magistrate & Secretary, DLSA Charkhi DadriMr. Sunil Kumar were the other guests present in the event. It proved to be a successful event with a gathering of around 5000 people who came from the nearby places.</p>
    <div className="row">
        <div className="col-md-3 col-sm-3 col-xs-12">
            <div className="augimage">
                <img src="assets/img/melaimg-1.jpg" />
            </div>
        </div>
        <div className="col-md-3 col-sm-3 col-xs-12">
            <div className="augimage">
                <img src="assets/img/melaimg-2.jpg" />
            </div>
        </div>
        <div className="col-md-3 col-sm-3 col-xs-12">
            <div className="augimage">
                <img src="assets/img/melaimg-3.jpg" />
            </div>
        </div>
        <div className="col-md-3 col-sm-3 col-xs-12">
            <div className="augimage">
                <img src="assets/img/melaimg-4.jpg" />
            </div>
        </div>
    </div>
    <br/><br/>
    </Typography>
    </Grid>
    <div className="leagalblock">
        <div className="row">
            <div className="col-md-12">
                <div className="head">
                    <h3>Report on Legal Aid Awareness Programme on ADR</h3>
                </div>
            </div>
        </div>
        <div className="row">
            <div className="col-md-6 col-sm-6 col-xs-12">
                <div className="text">
                    <p>A Legal Aid Awareness Programme was organized jointly by MVN University in association with the District Legal Services Authority (DLSA), Palwal at the District Court, Palwal. The programme aimed to create awareness about Alternative Dispute Resolution (ADR) mechanisms among students and the general public. Resource persons explained various ADR methods such as arbitration, mediation, conciliation, and Lok Adalats. Emphasis was laid on the importance of ADR in ensuring speedy, cost-effective, and amicable dispute resolution. Participants were informed about the role of DLSA in providing free legal aid and access to justice. The interactive session encouraged queries and active participation. Overall, the programme successfully enhanced legal awareness and promoted ADR as an effective justice delivery mechanism.</p>
                </div>
            </div>
            <div className="col-md-6 col-sm-6 col-xs-12">
                <div className="augimage">
                    <img src="assets/img/melaimg-5.jpg" />
                </div>
            </div>
        </div>
    </div>
    <br/><br/>
    <div className="leagalblock">
        <div className="row">
            <div className="col-md-12">
                <div className="head">
                    <h3>Report on Legal Aid Visit Camps</h3>
                </div>
            </div>
        </div>
        <div className="row">
            <div className="col-md-12">
                <div className="text">
                    <p>Legal Aid Visit Camps were organized by MVN University in association with the District Legal Services Authority (DLSA), Palwal at various locations in and around Palwal. The camps aimed to spread legal awareness and provide free legal assistance to the local community. Beneficiaries were informed about their legal rights, government welfare schemes, and access to free legal services. Special emphasis was laid on issues related to women, senior citizens, laborers, and marginalized sections of society. Legal experts addressed queries and guided individuals on dispute resolution. Awareness about Lok Adalats and ADR mechanisms was also shared. The camps witnessed active participation from local residents. Overall, the initiative successfully strengthened community awareness and access to justice.</p>
                </div>
            </div>
            <div className="col-md-3 col-sm-3 col-xs-12">
                <div className="augimage">
                    <img src="assets/img/melaimg-6.jpg" />
                </div>
            </div>
            <div className="col-md-3 col-sm-3 col-xs-12">
                <div className="augimage">
                    <img src="assets/img/melaimg-7.jpg" />
                </div>
            </div>
            <div className="col-md-3 col-sm-3 col-xs-12">
                <div className="augimage">
                    <img src="assets/img/melaimg-8.jpg" />
                </div>
            </div>
            <div className="col-md-3 col-sm-3 col-xs-12">
                <div className="augimage">
                    <img src="assets/img/melaimg-9.jpg" />
                </div>
            </div>
            <div className="col-md-3 col-sm-3 col-xs-12">
                <div className="augimage">
                    <img src="assets/img/melaimg-10.jpg" />
                </div>
            </div>
            <div className="col-md-3 col-sm-3 col-xs-12">
                <div className="augimage">
                    <img src="assets/img/melaimg-11.jpg" />
                </div>
            </div>
        </div>
    </div>
    <br/><br/>
    <div className="leagalblock">
        <div className="row">
            <div className="col-md-12">
                <div className="head">
                    <h3>Court Visit and DALSA Visit by University Students</h3>
                    <p><b>Date- 3rd May 2023</b></p>
                </div>
            </div>
        </div>
        <div className="row">
            <div className="col-md-12">
                <div className="text">
                    <p>The Faculty of Law at our University organized an <b>educational visit to the District Court</b> for its students as part of their practical learning program. The objective of the visit was to provide students with firsthand exposure to the <b>judicial system, court proceedings, and functioning of legal institutions</b>. During the visit, students observed live court proceedings in both civil and criminal courts. They witnessed the manner in which judges conduct hearings, how advocates present their arguments, and how evidence is examined. The visit gave them valuable insights into the <b>practical aspects of advocacy, client representation, and court decorum</b>.Students also had an interactive session with judges and senior advocates, who shared their experiences and guided them on the importance of ethics, preparation, and dedication in the legal profession. The session inspired students to develop a deeper understanding of justice delivery and the responsibilities of future lawyers.The visit proved to be an enriching experience, bridging the gap between <b>theoretical knowledge and practical application</b> of law. Students expressed great enthusiasm and acknowledged that the exposure helped them understand the functioning of the legal system.</p>
                </div>
            </div>
            <div className="col-md-3 col-sm-3 col-xs-12">
                <div className="augimage">
                    <img src="assets/img/melaimg-12.jpg" />
                </div>
            </div>
            <div className="col-md-3 col-sm-3 col-xs-12">
                <div className="augimage">
                    <img src="assets/img/melaimg-13.jpg" />
                </div>
            </div>
            <div className="col-md-3 col-sm-3 col-xs-12">
                <div className="augimage">
                    <img src="assets/img/melaimg-14.jpg" />
                </div>
            </div>
            <div className="col-md-3 col-sm-3 col-xs-12">
                <div className="augimage">
                    <img src="assets/img/melaimg-15.jpg" />
                </div>
            </div>
        </div>
    </div>
    <br/><br/>
    <div className="leagalblock">
        <div className="row">
            <div className="col-md-12">
                <div className="head">
                    <h3>Legal Awareness Program</h3>
                    <p><b>Date- 09th November 2023</b></p>
                </div>
            </div>
        </div>
        <div className="row">
            <div className="col-md-12">
                <div className="text">
                    <p>MVN University successfully organized a Legal Awareness Program aimed at sensitizing students, faculty members, and the community about their legal rights, duties, and the importance of law in everyday life. The program was conducted under the guidance of the Faculty of Law and witnessed enthusiastic participation from students of various departments. The session highlighted key areas such as fundamental rights and duties under the Constitution of India, women’s rights and protection laws, cyber laws, legal aid services, and the role of judiciary in safeguarding citizens’ rights. Eminent speakers, including legal experts, practicing advocates, and faculty members, shared their insights through interactive discussions . </p>
                </div>
            </div>
            <div className="col-md-3 col-sm-3 col-xs-12">
                <div className="augimage">
                    <img src="assets/img/melaimg-16.jpg" />
                </div>
            </div>
            <div className="col-md-3 col-sm-3 col-xs-12">
                <div className="augimage">
                    <img src="assets/img/melaimg-17.jpg" />
                </div>
            </div>
        </div>
    </div>
    <br/><br/>
    <div className="leagalblock">
        <div className="row">
            <div className="col-md-12">
                <div className="head">
                    <h3>DALSA Legal Awareness Program at College </h3>
                    <p><b>Date-10 September 2024</b></p>
                </div>
            </div>
        </div>
        <div className="row">
            <div className="col-md-12">
                <div className="text">
                    <p>Our college, in collaboration with the <b>District Legal Services Authority (DALSA),</b> organized a <b>Legal Awareness Program</b> to educate students about free legal aid and access to justice for all sections of society. Resource persons from DALSA explained the functioning of <b>Legal Services Authorities</b>, rights of marginalized groups, and various welfare schemes available under the Legal Services Authorities Act, 1987. Students actively participated in interactive sessions and discussion.</p>
                </div>
            </div>
            <div className="col-md-3 col-sm-3 col-xs-12">
                <div className="augimage">
                    <img src="assets/img/melaimg-18.jpg" />
                </div>
            </div>
            <div className="col-md-3 col-sm-3 col-xs-12">
                <div className="augimage">
                    <img src="assets/img/melaimg-19.jpg" />
                </div>
            </div>
        </div>
    </div>
    <br/><br/>
    <div className="leagalblock">
        <div className="row">
            <div className="col-md-12">
                <div className="head">
                    <h3>DALSA Legal Aid Camp  </h3>
                    <p><b>Date- 18th November 2024</b></p>
                </div>
            </div>
        </div>
        <div className="row">
            <div className="col-md-6">
                <div className="text">
                    <p>On <b>18th November 2024</b>, our college organized a <b>Legal Awareness Program</b> in collaboration with the <b>District Legal Services Authority (DALSA).</b> The session aimed to spread awareness about <b>free legal aid, alternative dispute resolution, and the rights of marginalized sections of society</b>. Officials from DALSA interacted with students, highlighting the provisions of the Legal Services Authorities Act, 1987, and shared real-life examples of how legal aid benefits the needy. Students actively participated through questions and discussions.</p>
                </div>
            </div>
            <div className="col-md-6 col-sm-6 col-xs-12">
                <div className="augimage">
                    <img src="assets/img/melaimg-20.jpg" />
                </div>
            </div>
        </div>
    </div>
    <br/><br/>
    <div className="leagalblock">
        <div className="row">
            <div className="col-md-12">
                <div className="head">
                    <h3>Report on World AIDS Day Observation</h3>
                    <p><b>Date- 01st December 2025</b></p>
                </div>
            </div>
        </div>
        <div className="row">
            <div className="col-md-12">
                <div className="text">
                    <p>MVN University observed <b>World AIDS Day on 1st December 2025</b> to raise awareness about HIV/AIDS and promote social responsibility. The programme aimed to educate students about prevention, treatment, and the importance of compassion towards people living with HIV/AIDS. Emphasis was laid on eliminating stigma and discrimination associated with the disease. The event highlighted the global significance of World AIDS Day as an annual international observance. Awareness messages focused on solidarity with affected individuals and honoring those who have lost their lives to HIV/AIDS. The programme was conducted in association with the <b>District Legal Services Authority, Palwal</b>, which also shared information regarding legal aid and support services. Overall, the observance successfully sensitized students and reinforced the message of awareness, empathy, and justice for all.</p>
                </div>
            </div>
            <div className="col-md-3 col-sm-3 col-xs-12">
                <div className="augimage">
                    <img src="assets/img/melaimg-21.jpg" />
                </div>
            </div>
            <div className="col-md-3 col-sm-3 col-xs-12">
                <div className="augimage">
                    <img src="assets/img/melaimg-22.jpg" />
                </div>
            </div>
            <div className="col-md-3 col-sm-3 col-xs-12">
                <div className="augimage">
                    <img src="assets/img/melaimg-23.jpg" />
                </div>
            </div>
            <div className="col-md-3 col-sm-3 col-xs-12">
                <div className="augimage">
                    <img src="assets/img/melaimg-24.jpg" />
                </div>
            </div>
        </div>
    </div>
    <br/><br/>
    <div className="leagalblock">
        <div className="row">
            <div className="col-md-12">
                <div className="head">
                    <h3>Report on Celebration of National Youth Day</h3>
                    <p><b>Date: 12th January 2026</b></p>
                </div>
            </div>
        </div>
        <div className="row">
            <div className="col-md-12">
                <div className="text">
                    <p><b>Venue:</b> MVN University, Palwal, Haryana<br />
<b>Organised by:</b> National Service Scheme (NSS), MVN University<br />
<b>In collaboration with:</b> District Legal Services Authority (DALSA) and Haryana Legal Services Authority (HALSA)
</p>
<p>MVN University, Palwal, commemorated <b>National Youth Day</b> with great enthusiasm and a sense of social responsibility. The programme was organised by the <b>National Service Scheme (NSS)</b> of the University in collaboration with <b>DALSA and HALSA</b>, with the objective of inspiring youth to imbibe the ideals of discipline, service, legal awareness, and nation-building as envisioned by Swami Vivekananda.</p>
<p>The programme was chaired by the <b>Vice-Chancellor, Prof. (Dr.) Arun Garg</b>, whose presence added academic depth and vision to the event. The programme was graced by <b>Pro Vice Chancellor Prof. Dr. N.P singh and Registrar, Prof. (Dr.) Yogender Singh</b>, who actively supported and encouraged youth-centric initiatives at the University. Also the presence of <b>Mr. Prashant Vashisht NSS Coordinator</b> who effortlessly made the programme hassle free.</p>
               <p>The event was honoured by the presence of esteemed legal professionals as guest speakers:</p>
                <p><b>●	Adv. Pinki</b><br /><b>●	Adv. Rachna </b><br /><b>●	Adv. Surendar</b></p>
                </div>
            </div>
            <div className="col-md-3 col-sm-3 col-xs-12">
                <div className="augimage">
                    <img src="assets/img/melaimg-25.jpg" />
                </div>
            </div>
            <div className="col-md-3 col-sm-3 col-xs-12">
                <div className="augimage">
                    <img src="assets/img/melaimg-26.jpg" />
                </div>
            </div>
            <div className="col-md-3 col-sm-3 col-xs-12">
                <div className="augimage">
                    <img src="assets/img/melaimg-27.jpg" />
                </div>
            </div>
            <div className="col-md-3 col-sm-3 col-xs-12">
                <div className="augimage">
                    <img src="assets/img/melaimg-28.jpg" />
                </div>
            </div>
        </div>
    </div>
    </Grid>
    

)
}
export default Legal_aid;